import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Footer.css";

//Import Image
import approval1Img from '../assets/image/approval1.svg';
import approval2Img from '../assets/image/approval2.svg';
import approval3Img from '../assets/image/approval3.svg';
import approval4Img from '../assets/image/approval4.svg';
import approval5Img from '../assets/image/approval5.svg';
import approval6Img from '../assets/image/approval6.svg';
import visa1Img from '../assets/image/visa1.svg';
import visa2Img from '../assets/image/visa2.svg';
import calImg from '../assets/image/cal.svg';
import mailImg from '../assets/image/mail.svg';
import clockkImg from '../assets/image/clockk.svg';
import whtsApImg from '../assets/image/whtsAp.svg';
import { isEnabled } from '../lib/promoFlags';

const Footer = ({ promoData = null, callbackEnabled = false, contactEnabled = true }) => {
  const mobilePrimary = normalizeRichText(promoData?.contact?.mobile_primary) || '07508522220';
  const mobileSecondary = normalizeRichText(promoData?.contact?.mobile_secondary);
  const emailPrimary = normalizeRichText(promoData?.contact?.email_primary) || 'info@classicbharatholidays.com';
  const callbackMobile = normalizeRichText(promoData?.enquiry?.callback_mobile) || '+91 9816348636';
  const whatsappNumber = normalizeRichText(promoData?.enquiry?.whatsapp_number) || '+91 8894360636';
  const showCallback = isEnabled(callbackEnabled, false);
  const showContact = isEnabled(contactEnabled, true);
  const copyrightText = normalizeRichText(promoData?.about?.copyright);
  const socialLinks = [
    { href: promoData?.social?.facebook, icon: 'fa-facebook-f' },
    { href: promoData?.social?.twitter, icon: 'fa-x-twitter' },
    { href: promoData?.social?.instagram, icon: 'fa-instagram' },
    { href: promoData?.social?.pinterest, icon: 'fa-pinterest-p' },
    { href: promoData?.social?.linkedin, icon: 'fa-linkedin-in' },
    { href: promoData?.social?.youtube, icon: 'fa-youtube' },
    { href: promoData?.social?.google, icon: 'fa-google' },
    { href: promoData?.social?.flickr, icon: 'fa-flickr' },
  ].filter((item) => item.href);

  return (
    <footer className="footer-section mt-100">
      <Container>
        <Row className="text-white">
          {/* Our Guarantee */}
          <Col md={6} lg={4} sm={6} className="mb-3">
            <h6 className="fw-bold">ABOUT COMPANY</h6>
            <p className="mb-20">
              {promoData?.about?.text || '100% Trust, 100% Value for money, 100% Support.'}
            </p>
            
            <div className="d-flex gap-2 footer-icons">
              {socialLinks.map((item, index) => (
                <a key={`${item.icon}-${item.href}-${index}`} href={item.href} target="_blank" rel="noreferrer"><i className={`fa-brands ${item.icon}`}></i></a>
              ))}
            </div>
          </Col>

          {/* Contact */}
          {showContact ? (
          <Col md={6} lg={4} sm={6} className="mb-3">
            <h6 className="fw-bold">CONTACT WITH US</h6>
            <p className="mb-20">
              <span> <img src={calImg} alt=""/> </span>
              <span>
                <a href={`tel:${toTelHref(mobilePrimary)}`}>{mobilePrimary}</a>
                {mobileSecondary ? <> , <a href={`tel:${toTelHref(mobileSecondary)}`}>{mobileSecondary}</a></> : null}
              </span>
            </p>
            <p className="mb-20">
            <span> <img src={mailImg} alt=""/> </span> <span> <a href={`mailto:${emailPrimary}`}>{emailPrimary}</a> </span>
            </p>
            {showCallback ? (
              <p className="mb-20">
              <span> <img src={clockkImg} alt=""/> </span> <span> <a href={`tel:${toTelHref(callbackMobile)}`}>{callbackMobile}</a> </span>
              </p>
            ) : null}
            {showCallback ? (
              <p className="mb-20">
              <span> <img src={whtsApImg} alt=""/>  </span> <span> <a href={`https://wa.me/${toWhatsAppHref(whatsappNumber)}`} target="_blank" rel="noreferrer">{whatsappNumber}</a> </span>
              </p>
            ) : null}
          </Col>
          ) : null}

          {/* Approved By */}
          <Col md={12} lg={showContact ? 4 : 8} sm={12} className="mb-3 cardImges">
            <h6 className="fw-bold ">APPROVED BY:</h6>
            <div className="d-flex flex-wrap gap-2">
              <img src={approval1Img} alt="" />
              <img src={approval2Img}  alt="" />
              <img src={approval3Img}  alt="" />
              <img src={approval4Img}  alt="" />
              <img src={approval5Img}  alt="" />
              <img src={approval6Img}  alt="" />
            </div>

            <h6 className="fw-bold weAccept mt-50">WE  ACCEPT:</h6>
            <div className="d-flex flex-wrap gap-2">
              <img src={visa1Img} alt="" />
              <img src={visa2Img} alt=""  />
              <img src={visa1Img} alt=""  />
              <img src={visa2Img} alt="" />
              <img src={visa1Img} alt=""  />
              <img src={visa2Img} alt="" />
            </div>

          </Col>

        </Row>

        {copyrightText ? (
          <div className="footer-copyright text-white text-center mt-4 pt-4">
            {copyrightText}
          </div>
        ) : null}
      </Container>
    </footer>
  );
};

function normalizeRichText(value) {
  const source = typeof value === 'string' ? value.trim() : '';

  if (!source) {
    return '';
  }

  if (typeof window === 'undefined') {
    return source.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
  }

  const parser = new DOMParser();
  const doc = parser.parseFromString(source, 'text/html');

  return (doc.body.textContent || '').replace(/\s+/g, ' ').trim();
}

function toTelHref(value) {
  return value.replace(/[^\d+]/g, '');
}

function toWhatsAppHref(value) {
  return value.replace(/\D/g, '');
}

export default Footer;
